/*
 * VULCAN
 */
import { __extends } from "tslib";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as operations from "./operations";
import { SecurityContext } from "./securityContext";
var Security = /** @class */ (function (_super) {
    __extends(Security, _super);
    /**
     * Initializes a new instance of the Security class.
     * @param credentials Subscription credentials which uniquely identify client subscription.
     * @param [options] The parameter options
     */
    function Security(credentials, options) {
        var _this = _super.call(this, credentials, options) || this;
        _this.applications = new operations.Applications(_this);
        _this.deployment = new operations.Deployment(_this);
        _this.directory = new operations.Directory(_this);
        _this.groups = new operations.Groups(_this);
        _this.permissions = new operations.Permissions(_this);
        _this.roles = new operations.Roles(_this);
        _this.tenants = new operations.Tenants(_this);
        _this.tenantSettings = new operations.TenantSettings(_this);
        _this.users = new operations.Users(_this);
        _this.authenticatedUser = new operations.AuthenticatedUser(_this);
        return _this;
    }
    return Security;
}(SecurityContext));
// Operation Specifications
export { Security, SecurityContext, Models as SecurityModels, Mappers as SecurityMappers };
export * from "./operations";
//# sourceMappingURL=security.js.map